import { Cooperative } from 'models';
import { Box } from 'components';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useStyles } from './style';

interface Props {
  cooperative: Cooperative;
  handleOpen: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const CooperativePickerOutput: React.FC<Props> = ({
  cooperative,
  handleOpen,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.pointer} onClick={handleOpen}>
      <span className={classes.cooperativeName}>{cooperative.Name}</span>
      <KeyboardArrowDownIcon className={classes.icon} />
    </Box>
  );
};

export default CooperativePickerOutput;
